import { login } from "./login.entry.js";
import { isLoggedIn } from "./isLoggedIn.entry.js";
import { hydrateBoards } from "./hydrateBoards.entry.js";
import { authorizePublicUserEntry } from "./authorizePublicUser.entry.js";

export default {
   login,
   isLoggedIn,
   hydrateBoards,
   authorizePublicUser: authorizePublicUserEntry,
};
